import classnames from 'classnames';
import React, { JSX } from 'react';

import '@eika/action-panel-card-style';
import { Icon, IconTypes } from '@eika/icon';
import { Label, LabelProps } from '@eika/label';

export type ActionPanelCardProps = {
    title: string | JSX.Element;
    subText?: string | JSX.Element;
    label?: LabelProps;
    icon: IconTypes;
    ariaLabel?: string;
} & React.PropsWithoutRef<JSX.IntrinsicElements['button']>;

const defineElement = (el: JSX.Element | string, className: string): JSX.Element => {
    return typeof el === 'string' ? <span className={className}>{el}</span> : React.cloneElement(el, { className });
};

const ActionPanelCard = ({
    title,
    subText,
    label,
    icon,
    className,
    onClick,
    id,
    ariaLabel,
    ...rest
}: ActionPanelCardProps): JSX.Element => {
    return (
        <button
            type="button"
            className={classnames('sgw-action-panel-card', className, { 'align-center': !label && !subText })}
            onClick={onClick}
            aria-label={ariaLabel}
            {...rest}
        >
            <div className="sgw-action-panel-card__content">
                {label && <Label {...label} />}
                <div id={id} className="sgw-action-panel-card__text-wrapper">
                    {title && defineElement(title, 'sgw-action-panel-card__title')}
                    {subText && defineElement(subText, 'sgw-action-panel-card__sub-text')}
                </div>
            </div>
            <Icon type={icon} className="sgw-action-panel-card__icon" />
        </button>
    );
};

export default ActionPanelCard;
